import { useEffect } from 'react'
import { isBring, isPosten } from '../utils/env'

export const useSetBackgroundColor = () => {
  const theme = themeFromParam() || themeFromDomain()
  useEffect(() => {
    const htmlElement = document.documentElement

    htmlElement.classList.remove(...themes)
    htmlElement.classList.add(theme)
  }, [theme])
}

export type Theme = (typeof themes)[number]
export const themes = ['bring', 'glow']

function themeFromDomain(): Theme {
  if (isBring()) {
    return 'bring'
  } else if (isPosten()) {
    return 'bring'
  } else {
    return 'glow'
  }
}

function themeFromParam(): Theme | undefined {
  const params = new URLSearchParams(window.location.search)
  const theme = params.get('theme') ?? ''

  if (isValidTheme(theme)) {
    return theme
  }
}

function isValidTheme(s: string): s is Theme {
  return (themes as Readonly<string[]>).includes(s)
}
